<template>
  <d-modal
    :key="'popup-doc-' + isVisible"
    :class="{ 'popup-form': true, 'is-hidden': !isVisible }"
    @close="onClosePopup"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja dokumentu</template>
          <template v-else>Dodawanie dokumentu</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="patient-documents-form"
        tag="form">
        <div class="form-group">
          <label for="category-id">
            Kategoria dokumentu:
          </label>
          <validation-provider
            :rules="'required'"
            name="category-id"
            v-slot="{ errors }">
             <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': errors.length
              }">
              <filter-select
                :disabled="isEdit"
                v-model="data.category_id"
                style="width: 100%;"
                :endpoint-items="'/edocuments/category/items'"
                :data-id="data.category_id"
                :reduce="obj => obj.id"
                :endpoint-item="'/edocuments/category/item/'"
                :placeholder="data.category_name ? data.category_name : 'Wyszukaj kategorie...'" />
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div
          v-if="data.category_id"
          class="form-group">
          <validation-provider
            :rules="'required'"
            name="edocument-id"
            v-slot="{ errors }">
            <label for="edocument-id">
              Lista dokumentów:
            </label>
             <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                v-model="data.edocument_id"
                :options="eDocuments"
                :reduce="doc => doc.id"
                placeholder="Wybierz dokument"
                label="name">
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div
          v-if="!isEdit && !!data.category_id && !!data.edocument_id && edocumentTemplateFilename"
          class="form-group">
          <d-button
            style="width: 100%;"
            theme="primary"
            class="mr-2"
            outline
            :disabled="downloadInProgress"
            @click.prevent="downloadDoc(data.edocument_id)">
            <i class="material-icons">cloud_download</i>
            <span class="ml-2">Pobierz wzór dokumentu</span>
          </d-button>
        </div>
        <div
          v-if="(!!data.category_id && !!data.edocument_id) || isEdit"
          class="form-group">
          <label for="comments">
            Krótki opis:
          </label>
          <validation-provider
            rules="required"
            name="name"
            v-slot="{ errors }">
            <d-input
              :state="errors.length ? 'invalid' : null"
              v-model="data.description" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div
          v-if="!!(data.category_id && !!data.edocument_id) || isEdit"
          class="form-group">
          <label for="uploaded_file">
            Skan dokumentu:
          </label>
          <validation-provider
            :rules="'required'"
            :name="'scan'"
            v-slot="{ errors }">
            <file-input
              class="form-group"
              :onChange="setImage"
              :id="'scan'" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center overlay-loading"
        style="z-index: 10000">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import FilterSelect from '@/components/others/FilterSelect';
import ListUtils from '@/utils/ListUtils.js';
import debounce from 'lodash.debounce';
import axios from 'axios'
import api from '@/api'

export default {
  name: 'patients-form-docs-popup',
  components: { FilterSelect },
  props: {
    document: {
      defualt: null,
      type: Object
    },
    isVisible: {
      default: false,
      type: Boolean
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    patientId: {
      required: true,
      type: Number
    },
    visitId: {
      required: false,
      type: Number
    }
  },
  computed: {
    isEdit () {
      return !!(this.document && this.document.id);
    },
    edocumentTemplateFilename () {
      if (!this.data.edocument_id) {
        return null;
      }

      let foundEDoc = this.eDocuments.find(item => item.id === this.data.edocument_id);
      if (foundEDoc && foundEDoc.filename) {
        return foundEDoc.filename;
      }

      return null;
    }
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue) {
        Vue.set(this, 'loaded', false);
        this.preparePopup();
      }
    },
    'data.category_id': function () {
      if (this.isVisible && this.loaded) {
        this.data.edocument_id = ''
        Vue.set(this, 'loaded', false);
        this.debouncedLoadFilteredData();
      }
    }
  },
  data () {
    return {
      data: {
        category_id: '',
        category_name: '',
        description: '',
        edocument_id: '',
        id: 0,
        patient_id: '',
        uploaded_file: {}
      },
      downloadInProgress: false,
      eDocuments: [],
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    Vue.set(this, 'loaded', false);
  },
  methods: {
    preparePopup () {
      if (this.document && this.document.id) {
        Object.assign(this.data, this.document);
        Vue.set(this.data, 'category_id', this.data.edocument.category_id);
        Vue.set(this.data, 'edocument_id', this.data.edocument.id);
      } else {
        this.data.id = '';
        this.data.category_id = '';
        this.data.category_name = '';
        this.data.description = '';
        this.data.edocument_id = '';
        this.data.patient_id = this.patientId;
        this.data.uploaded_file = '';
      }

      this.loadFilteredDocuments();

      Vue.nextTick(() => {
        if (this.$refs['patient-documents-form']) {
          this.$refs['patient-documents-form'].reset();
        }
      })
    },
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredDocuments();
    }, 250),
    loadFilteredDocuments () {
      let where = {
        category_id: this.data.category_id
      };
      ListUtils.loadItemsData(this, {
        endpoint: '/edocuments/items?ignore_users_filters=1',
        listField: 'eDocuments',
        pagination: false,
        params: {
          where
        }
      });
    },
    setImage(event) {
      this.data.uploaded_file = event.target.files[0];
    },
    validateForm () {
      FormUtils.validate(this.$refs['patient-documents-form'], this.submitForm);
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {
        name: this.data.description,
        description: this.data.description,
        edocument_id: this.data.edocument_id,
        patient_id: this.isEdit ? this.document.patient_id : this.patientId,
        visit_id: this.visitId,
        category_id: this.data.category_id,
      };

      if (this.data.uploaded_file) {
        formDataToSend.uploaded_file = this.data.uploaded_file;
        imageFields = ['uploaded_file'];
      }

      let endpointUrl = this.isEdit ? '/patients/edocuments/update/' + this.document.id : '/patients/edocuments/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano dokument',
        successText: 'Wybrany dokument został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje dokumentu nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback();
          this.onClosePopup();
        }
      }, imageFields);
    },
    downloadDoc (id) {
      let filename = this.isEdit ? this.document.filename : this.edocumentTemplateFilename;
      axios({
        url: `${api}edocuments/get-file/` + (this.data.edocument_id || id),
        method: 'POST',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        link.click();
        this.downloadInProgress = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
        this.downloadInProgress = false;
      });
    }
  }
};
</script>

<style lang="scss">
  @import '../../../assets/scss/variables/mixins';
  .popup-box-buttons {
    @include popupButtons
  }
  .popup-form {
    &.is-hidden {
      display: none!important;
      pointer-events: none!important;
    }

    .modal-dialog {
      margin-top: 5rem;
    }
  }

  .vs__dropdown-option {
    white-space: normal;
  }
</style>
